import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchWithError } from "src/react-query/fetchWithError";
import { queryKeys } from "src/react-query/queryKeys";
import { authSlice } from "src/store/auth/auth.slice";
import { teamsSlice } from "src/store/teams/teams.slice";
import Token from "src/util/Token";

// Public routes that don't require profile API calls
const PUBLIC_ROUTES = ['/active-transaction', '/check-transaction-status'];

export const useUser = () => {
  const { isAuthenticated, user } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const location = useLocation();

  // Check if current route is a public route
  const isPublicRoute = PUBLIC_ROUTES.some(route => location.pathname.startsWith(route));

  // Fetch profile if authenticated but don't have user roles/teams yet
  // User object from JWT exists but needs full profile data with roles
  const shouldFetchProfile = isAuthenticated && (!user || !user.role) && !isPublicRoute;

  return useQuery(queryKeys.user(), fetchWithError, {
    enabled: shouldFetchProfile,
    retry: false,
    onError: () => {
      // Stale / invalid token: log out instead of hanging the whole app on <Loader/>.
      Token.clear();
      dispatch(authSlice.actions.setIsAutheticated(false));
    },
    onSuccess: (data) => {
      dispatch(authSlice.actions.setUser(data?.data));

      // Automatically select the first team if available
      const userRoles = data?.data?.role;
      if (userRoles && userRoles.length > 0) {
        const firstTeamId = userRoles[0]?.teamId;
        if (firstTeamId) {
          dispatch(teamsSlice.actions.setTeamId(firstTeamId));
        }
      }
    },
  });
};
